import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  FaUser,
  FaPhone,
  FaEnvelope,
  FaGraduationCap,
  FaAddressCard,
  FaCalendarAlt,
  FaUserTie,
} from "react-icons/fa";
import Style from "../Style/EnrollForm.module.scss";
const baseURL = process.env.REACT_APP_BASE_URL;

const EnrollForm = () => {
  const [formData, setFormData] = useState({
    title: "",
    name: "",
    father_name: "",
    dob: "",
    phone: "",
    email: "",
    qualification: "",
    address: "",
    course: "",
  });

  const [courses, setCourses] = useState([]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const res = await axios.get(`${baseURL}/api/get/skills`);
        setCourses(res.data);
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };
    fetchCourses();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${baseURL}/api/enroll`, formData);
      alert("✅ Enrolled Successfully!");
      setFormData({
        title: "",
        name: "",
        father_name: "",
        dob: "",
        phone: "",
        email: "",
        qualification: "",
        address: "",
        course: "",
      });
    } catch (error) {
      console.error("❌ Enrollment error:", error);
      alert("Something went wrong!");
    }
  };

  return (
    <div className={Style.EnrollForm}>
      <div className={Style.wrapper}>
        <form onSubmit={handleSubmit} className={Style.EnrollFormDisk}>
          <div className={Style.EnrollFormBar}>
            <h2>Enroll Now</h2>
          </div>
          <div className={Style.EnrollFormTitle}>
            <select
              name="title"
              value={formData.title}
              onChange={handleChange}
              required
            >
              <option value="">Mr./Mrs./Miss/Dr. (pick one)</option>
              <option value="Mr.">Mr.</option>
              <option value="Mrs.">Mrs.</option>
              <option value="Miss.">Miss.</option>
              <option value="Dr.">Dr.</option>
            </select>
          </div>
          <div className={Style.EnrollFormTitle}>
            <label>
              <FaUser /> Full Name
            </label>
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className={Style.EnrollFormTitle}>
            <label>
              <FaUserTie /> Father's Name
            </label>
            <input
              type="text"
              name="father_name"
              placeholder="Father's Name"
              value={formData.father_name}
              onChange={handleChange}
              required
            />
          </div>
          <div className={Style.EnrollFormTitle}>
            <label>
              <FaCalendarAlt /> Date of Birth
            </label>
            <input
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              required
            />
          </div>
          <div className={Style.EnrollFormTitle}>
            <label>
              <FaPhone /> Mobile Number
            </label>
            <input
              type="tel"
              name="phone"
              placeholder="Mobile Number"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>
          <div className={Style.EnrollFormTitle}>
            <label>
              <FaEnvelope /> Email
            </label>
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className={Style.EnrollFormTitle}>
            <label>
              <FaGraduationCap /> Course
            </label>
            <select
              name="course"
              value={formData.course}
              onChange={handleChange}
              required
            >
              <option value="">Select a Course</option>
              {courses.map((course) => (
                <option key={course.id} value={course.title}>
                  {course.title}
                </option>
              ))}
            </select>
          </div>
          <div className={Style.EnrollFormTitle}>
            <label>
              <FaGraduationCap /> Qualification
            </label>
            <input
              type="text"
              name="qualification"
              placeholder="Qualification"
              value={formData.qualification}
              onChange={handleChange}
            />
          </div>
          <div className={Style.EnrollFormTitle}>
            <label>
              <FaAddressCard /> Address
            </label>
            <textarea
              name="address"
              placeholder="Your Address"
              value={formData.address}
              onChange={handleChange}
            ></textarea>
          </div>
          <button type="submit" className={Style.EnrollFormButton}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default EnrollForm;
